module.exports = __webpack_public_path__ + "img/qiweijie.026eb2fd.jpg";